// extracted by mini-css-extract-plugin
export default {"list":"Workspaces_list__l2+O+","placeholderImage":"Workspaces_placeholderImage__ILK72"};